let currentVersion = null;

export function startVersionChecking(intervalMs = 5 * 60 * 1000) {
  if (process.env.NODE_ENV !== "production") return;
  checkVersion();
  setInterval(checkVersion, intervalMs);
}

async function checkVersion() {
  try {
    if (process.env.NODE_ENV !== "production") return;

    const response = await fetch("/version.json", { cache: "no-cache" });
    const data = await response.json();

    if (!currentVersion) {
      currentVersion = data.version;
    } else if (currentVersion !== data.version) {
      window.location.reload(true);
    }
  } catch (err) {
    console.error("Versiotarkistus epäonnistui", err);
  }
}
